<template>
	<div id="login">
		<div class="container">
			<div id="logo"><img src="@/assets/images/parts/logo-red.png" /></div>
			<div class="form-horizontal">
				<div v-if="loginError" class="alert alert-danger" role="alert">{{loginError}}</div>
				<div class="form-group">
					<label for="loginid" class="control-label">ユーザ名</label>
					<div>
						<input type="text" class="form-control" id="loginid" v-model="uname" @input="inputUname">
					</div>
				</div>
				<div class="form-group">
					<label for="loginpwd" class="control-label">パスワード</label>
					<div>
						<input type="password" class="form-control" id="loginpwd" v-model="pwd" @input="inputPwd">
					</div>
				</div>
				<div class="flexrow">
					<Button
						label="ログイン"
						@click-button="actionLogin"
					></Button>
				</div>

				<div class="row marginBottom20">
					<div class="col-xs-12 text-right inline-link">
						<!--
						<a class="visible-xs-block visible-sm-inline visible-md-inline visible-lg-inline" href="#" @click.prevent="clickRegister" title="ユーザー登録"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>ユーザー登録</a>
						-->
						<a href="#" @click.prevent="clickLostPassword" title="ユーザー名・パスワードをお忘れの方">ユーザー名・パスワードをお忘れの方</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Button from '@/components/common/Button';

	export default {
		components: {
			Button
		},
		props: {
		},
		data() {
			return {
				'uname': '',
				'pwd': '',
			}
		},
		computed: {
			isLogin() {
				return this.$store.getters['commonStore/isLogin'];
			},
			loginError() {
				return this.$store.getters['commonStore/getLoginError'];
			}
		},
		methods: {
			async actionLogin() {
				this.$store.commit('commonStore/setLoading', true);

				const param = {
					'id': this.uname,
					'password': this.pwd
				};
				await this.$store.dispatch('commonStore/login', param);
				if(this.isLogin) {
					// ユーザー情報を取得しておきます
					this.$store.dispatch('commonStore/user');
					this.$router.push('/top');
				} else {
					this.$store.commit('commonStore/setLoading', false);
				}
			},
			clearLoginError() {
				if(this.loginError) {
					this.$store.commit('commonStore/setLoginError', '');
				}
			},
			inputUname() {
				this.clearLoginError();
			},
			inputPwd() {
				this.clearLoginError();
			},
			clickLostPassword() {
				this.$router.push('/lostpassword');
			}
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	#login {
		display: flex;
		justify-content: center;
		align-items: center;

		margin: 0 auto;
		padding: 0 8px 0;
		height: 100vh;
		
		.container {
			width: auto;
			max-width: 400px;
			
			#logo {
				text-align: center;
				margin-bottom: 1em;
				img {
					max-width: 90%;
				}
			}
			.form-horizontal {
				max-width: 240px;
				margin-left: auto;
				margin-right: auto;
				.form-group {
					margin-left: 0;
					margin-right: 0;
				}
				.flexrow {
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
			.inline-link {
				margin-top: 3em;
			}
		}
	}
</style>
